<template>
  <div class="homeIndex">
    <div class="contairs">
      <div class="head">
        <router-link :to="{ name: 'home' }" style="margin-top: 4px">
          <!-- <div class="logoCenter">
            <img class="logo" src="https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/logo.png" alt="">
             <img class="logo" src="https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/logo.png" alt="">
            <div class="logo-name">
              <div class="logoTitle">杭 法 案 件 管 理 系 统</div>
              <div class="logoEnglish">HANGFA CASE MANAGEMENT SYSTEM</div>
            </div>
          </div> -->
          <img class="logo-name" :src="name == '杭法' ? 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/logo-hangfa.png' : name == '萧银' ? 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/2026/06/08/%E8%90%A7%E9%93%B6%E6%A1%88%E4%BB%B6%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F.png' : 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/logo-name2.png'
            " />
        </router-link>
        <div class="rt">
          <SlideMenu :curs="curs" @setRoute="setRoute" @backhome="backhome" @setStatus="setStatus"
            @setParent="setParent"></SlideMenu>
          <div class="my">
            <div class="name">
              <img src="../assets/img/user.png" alt="" />
              <span>{{ user.uname }}</span>
              <a-icon type="caret-down" />
            </div>
            <div class="drap">
              <router-link :to="{ name: 'userGroup' }" @click.native="status = true" v-if="user.id == 1"
                tag="a">机构管理</router-link>
              <router-link :to="{ name: 'accountGroup' }" @click.native="status = true" v-if="user.id == 1"
                tag="a">权限管理</router-link>
              <router-link :to="{ name: 'accountManage' }" @click.native="status = true" v-if="user.id == 1"
                tag="a">用户管理</router-link>
              <router-link :to="{ name: 'accountOperationLog' }" @click.native="status = true" v-if="user.id == 1"
                tag="a">操作日志</router-link>
              <router-link :to="{ name: 'accountLoginlist' }" @click.native="status = true" tag="a">登录日志</router-link>
              <a href="javascript:void(0);" @click="visible = true">修改密码</a>
              <a href="javascript:void(0);" @click="out">退出</a>
            </div>
          </div>
          <Repass :visible="visible" @close="visible = false"></Repass>
        </div>
      </div>
      <div class="mains">
        <div class="bread" v-if="status">
          <a-breadcrumb>
            <a-breadcrumb-item v-for="(i, index) in bread" :key="index">
              <a href="javascript:void(0);" @click="went(i)" :style="{
                color: index == bread.length - 1 ? '#1D8BFE' : '#102B4B',
              }"><b class="breadTitle">{{ i }} </b>
              </a>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
        <div class="slide-card-child contair" v-if="!status">
          <!-- <div style="width: 100%;text-align: center;height: 60px;line-height: 60px;font-size: 1.125rem;border-bottom: 1px solid rgba(0, 0, 0, 0.06);font-weight: bold;color: #102B4B;margin-bottom: 20px;">{{ headTitle }}</div> -->
          <div :class="['item-card', title == j.title ? 'item-act' : '']"
            :style="{ width: nowSlide.length < 8 ? '165px' : '' }" v-if="$common.AUTH(j.key) && linkStatus"
            v-for="(j, ind) in nowSlide" :key="ind" @click="linkTo(j)">
            <img :src="hoverIndex === ind || title == j.title ? j.icon : j.icon1" class="j-icon" />{{ j.title }}
          </div>
        </div>
        <div class="contair" style="border-radius: 8px">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="lett">
        <div class="p" style="margin-left: 35px">
          {{ name == "杭法" ? "杭法案件管理系统" : name == "萧银" ? "萧银案件管理系统" : name == "浩韵" ? "浩韵案件管理系统" : "" }}
        </div>
        <a href="https://beian.miit.gov.cn" target="_blank">
          <img src="../assets/img/gh.png" />{{
            name == "杭法" ? "浙ICP备2025164053号" : "浙ICP备2022024828号"
          }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import SlideMenu from "@/components/slide";
import LeftMenu from "@/components/leftMenu";
import Header from "@/components/header";
import Repass from "./repass";
import { mapActions } from "vuex";
import slideRouter from "@/components/slide/slide_n";
import User1 from "@/components/slide/user1";
import store from "@/store/index";
import { sLogOutUser } from "@/server/api";
import { Tacitly } from "@/assets/js/Tacitly";
function putSlide(menu, userId) {
  const baseMenu = [
    {
      title: "法院目录",
      link: "directoryManage",
      key: "court:list",
      other: true,
      icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/mulv.png",
      icon1:
        "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/mulv1.png",
      cur: "3-0",
    },
  ];
  if (userId == 1) {
    menu[7].child = [...baseMenu, ...User1];
    return menu;
  } else {
    menu[7].child = baseMenu;
    return menu;
  }
}
export default {
  data() {
    return {
      curs: -1,
      visible: false,
      bread: [],
      showImage: {},
      name: "",
      slide: putSlide(slideRouter, this.$store.state.user.id),
      nowSlide: [],
      title: "",
      status: true,
      linkStatus: true,
      headTitle: "",
      hoverIndex: -1,
    };
  },
  created() {
    this.getCurrentMenuByRoute();
    this.getKey();
    this.router();
    this.name = Tacitly.name;
  },
  components: {
    SlideMenu,
    LeftMenu,
    Header,
    Repass,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    getCurrentMenuByRoute() {
      const currentRouteName = this.$route.name;
      for (const parentItem of this.slide) {
        if (parentItem.child && parentItem.child.length) {
          this.headTitle = parentItem.title;
          const matchedChild = parentItem.child.find(
            (child) => child.link === currentRouteName
          );
          if (matchedChild) {
            const list = parentItem.child.filter(ele => {
              // 满足权限就保留，不满足就过滤掉
              return this.$common.AUTH(ele.key)
            })
            this.nowSlide = list;
            if (this.nowSlide.length == 0) {
              this.status = true
            } else {
              this.status = false;
            }
            this.title = matchedChild.title;
            this.curs = parentItem.cur;
            return;
          }
        }
      }
      this.status = true;
      this.nowSlide = [];
    },
    backhome(type) {
      this.status = true;
      this.linkStatus = false;
      this.title = "";
    },
    setParent(item) {
      this.status = true
      this.title = item.title;
    },
    setStatus(item) {
      this.nowSlide = item
      if (this.nowSlide.length == 0) {
        this.status = true
      } else {
        this.status = false;
        this.linkStatus = true;
      }
      this.title = item[0].title;
    },
    setRoute(item) {
      this.headTitle = item.title;
      this.title = "";
      this.linkStatus = true;
      this.nowSlide = item.child;
      if (this.nowSlide && this.nowSlide.length == 0) {
        this.status = true
      } else {
        this.status = false;
      }
      if (item.child) {
        this.title = item.child[0].title;
      }
    },
    linkTo(j) {
      if (
        !this.$common.AUTH(j.key) &&
        this.$store.state.user.id != 1 &&
        j.other
      ) {
        this.$message.error("暂无权限");
        return false;
      }
      store.dispatch("updateWatermarks");
      this.title = j.title;
      if (j.link != this.$route.name) {
        this.$router.push({ name: j.link });
      } else {
        this.$router.go(0);
      }
    },
    went(i) {
      let slideMenu = [];
      slideRouter.map((ele) => {
        slideMenu.push({ title: ele.title, link: ele.link });
        if (ele.child) {
          ele.child.map((s) => {
            slideMenu.push({ title: s.title, link: s.link });
          });
        }
      });
      const routerLink = slideMenu.filter((ele) => {
        return ele.title === i;
      });
      if (routerLink.length > 0) {
        this.$router.push({ name: routerLink[0].link });
      }
    },
    ...mapActions({
      getKey: "Dictionary/getKey",
    }),
    router() {
      let route = this.$route;
      let meta = route.meta;
      this.curs = meta.curs;
      let bread = meta.title.split(",");
      if (meta.bet) {
        bread.push(route.params.id > 0 ? "修改分期" : "添加分期");
      }
      this.bread = bread;
    },
    out() {
      sLogOutUser().then((res) => { }); //退出登录
      this.$message.success({ content: "退出成功", key: "updatable" });
      localStorage.clear();
      this.$store.dispatch("setuser", {});
      this.$router.push("/login"); //重定向路由到登录页
      window.location.reload(); //刷新页面
    },
  },
  watch: {
    $route(to, from) {
      this.router();
    },
  },
};
</script>

<style lang="less" scoped>
.slide-card-child {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  background-color: #ffffff27;
}

.mb10 {
  margin-bottom: 10px;
}

.item-card {
  width: 100%;
  /* max-width: 180px; */
  height: 45px;
  text-align: center;
  line-height: 45px;
  color: #d1d0d0;
  font-size: 1rem !important;
  cursor: pointer;
  padding: 0 15px;
  align-items: center;

  .j-icon {
    width: 15px;
    height: 15px;
    margin: -3px 6px 0 0;
  }

}

.breadTitle {
  font-size: 16.5px !important;
}

.item-act {
  background-color: #fff;
  color: #1d8bfe;
  font-weight: bold;
  padding: 0 15px;
  cursor: pointer;
}

.logoCenter {
  display: flex;
  width: 334px;
  font-weight: 600;
  align-items: center;
  gap: 8px;
}

.logo {
  width: 55px;
  height: 55px;
  /* 给logo也添加轻微阴影，保持整体风格统一 */
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.3));
}

.logo-name {
  max-width: 20em !important;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
}

.logoTitle {
  font-size: 22px;
  // letter-spacing: 8px;
  white-space: nowrap;
  color: #ffffff;
}

.logoEnglish {
  word-spacing: 2px;
  font-size: 0.75rem;
  white-space: nowrap;
  color: #ffffff;
}

#components-layout-demo-basic {
  text-align: center;
}

#components-layout-demo-basic .ant-layout-header {
  background: #7dbcea !important;
  color: #fff;
}

#components-layout-demo-basic .ant-layout-sider {
  background: #3ba0e9;
  color: #fff;
  line-height: 120px;
}

#components-layout-demo-basic .ant-layout-content {
  background: rgba(16, 142, 233, 1);
  color: #fff;
  min-height: 120px;
  line-height: 120px;
}

.slide {
  width: 90%;
  justify-content: end;
  align-items: center;
}

#components-layout-demo-basic>.ant-layout {
  margin-bottom: 48px;
}

#components-layout-demo-basic>.ant-layout:last-child {
  margin: 0;
}

.homeIndex {
  min-width: 1080px;
  // width: 100%;
  height: auto;
  background-image: url("../assets/img/tp.jpg");
  background-repeat: no-repeat;
  background-position: top center;
  background-color: #f4f5f9;
  // background: url("../assets/img/tp.jpg") no-repeat center top #f4f5f9;

  .title {
    text-align: center;
    color: #fff;
    margin: 20px auto 30px;

    .main-title {
      font-size: 21px;
      font-weight: 900;
    }

    .min-title {
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 1px;
    }
  }

  .open {
    display: none;
  }

  .footer {
    // margin-top: 20px;
    width: 100%;
    height: 75px;
    opacity: 0.5;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 0.875rem;
    color: #222121;
    line-height: 26px;

    a {
      font-size: 0.875rem;
      color: #222121;
      display: flex;
      align-items: center;
      line-height: 26px;

      img {
        margin-right: 10px;
      }

      &:hover {
        color: #128aff;
      }
    }
  }

  min-height: 100vh;

  .contairs {
    padding: 0 80px 20px;
  }

  .head {
    max-height: 6.9rem;
    position: relative;
    z-index: 111;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 1.5rem 0;
    align-items: flex-start;
    align-items: center;

    .rt {
      width: 100%;
      color: #fff;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
    }
  }

  .mains {
    overflow: hidden;
  }

  .contair {}

  .bread {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 11;
    // margin-bottom: 10px;
  }

  .rt {
    position: relative;

    .my {
      font-size: 16px;
      padding-top: 1.25rem;

      .name {
        min-width: 100px;
        font-weight: 500;
        padding-bottom: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;

        img {
          margin-right: 6px;
        }
      }
    }
  }

  .drap {
    width: 6.5rem;
    // height: 80px;
    background: #fff;
    box-shadow: 0 0 3px #ccc;
    position: absolute;
    right: 0;
    top: 62px;
    display: none;

    a {
      font-size: 0.875rem;
      display: block;
      line-height: 40px;
      padding-left: 20px;
      border-bottom: 1px solid #f8f8f8;
      color: #696c76;

      &:hover {
        color: #128aff;
      }
    }
  }

  .head {
    .my {
      margin-left: 20px;

      span {
        margin-right: 10px;
      }

      &:hover {
        .drap {
          display: block;
        }
      }
    }
  }
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 16px;
  /* 垂直滚动条宽度 */
  height: 16px;
  /* 水平滚动条高度 */
  background-color: transparent;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 8px;
  margin: 4px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  border: 4px solid transparent;
  background-clip: content-box;
  min-height: 40px;
}

/* 滚动条滑块悬停状态 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.6);
}

/* 滚动条滑块激活状态 */
::-webkit-scrollbar-thumb:active {
  background-color: rgba(0, 0, 0, 0.4);
}

/* 滚动条角落 */
::-webkit-scrollbar-corner {
  background-color: transparent;
}
</style>